<template>
  <div class="meal-order-container">
    <!-- 页面标题 -->
    <div class="page-header">
      <h2>长者点餐及订单管理</h2>
      <el-button type="primary" @click="showOrderList = true">查看历史订单</el-button>
    </div>

    <!-- 核心点餐区域 -->
    <div class="order-main">
      <!-- 左侧：老人信息选择区 -->
      <div class="elderly-section">
        <el-card shadow="hover" class="elderly-card">
          <div slot="header" class="card-header">
            <span>选择就餐长者</span>
          </div>
          
          <!-- 老人下拉选择 -->
            <el-select
              v-model="selectedElderlyId"
              placeholder="请选择长者"
              style="width: 100%"
              @change="getElderlyInfo"
            >
              <el-option
                v-for="item in elderlyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>

          <!-- 老人信息展示 -->
          <div class="elderly-info" v-if="currentElderly">
            <el-descriptions :column="1" border>
              <el-descriptions-item label="姓名">{{ currentElderly.name }}</el-descriptions-item>
              <el-descriptions-item label="年龄">{{ currentElderly.age }}岁</el-descriptions-item>
              <el-descriptions-item label="联系电话">{{ currentElderly.phone }}</el-descriptions-item>
              <el-descriptions-item label="所属社区">{{ currentElderly.community }}</el-descriptions-item>
              <el-descriptions-item label="就餐类型">{{ currentElderly.diningType === 1 ? '堂食' : '送餐上门' }}</el-descriptions-item>
              <el-descriptions-item label="送餐地址" v-if="currentElderly.diningType === 2">
                {{ currentElderly.address }}
              </el-descriptions-item>
              <el-descriptions-item label="特殊备注">{{ currentElderly.remark || '无' }}</el-descriptions-item>
            </el-descriptions>
          </div>

          <!-- 已选菜品汇总 -->
          <div class="selected-foods" v-if="cartList.length > 0">
            <div class="cart-header">已选菜品</div>
            <div class="cart-item" v-for="item in cartList" :key="item.id">
              <span>{{ item.name }} x {{ item.quantity }}</span>
              <span class="price">¥{{ item.price.toFixed(2) }}</span>
            </div>
            <div class="cart-total">
              <span>合计：</span>
              <span class="total-price">¥{{ totalAmount.toFixed(2) }}</span>
            </div>
          </div>
        </el-card>
      </div>

      <!-- 右侧：菜品列表选择区 -->
      <div class="food-section">
        <el-card shadow="hover" class="food-card">
          <div slot="header" class="card-header">
            <span>菜品列表</span>
            <el-input
              v-model="foodSearch"
              placeholder="搜索菜品名称"
              style="width: 200px"
              clearable
            ></el-input>
          </div>

          <!-- 菜品分类标签 -->
          <el-tabs v-model="activeFoodType" type="card" style="margin-bottom: 15px">
            <el-tab-pane label="全部" name="all"></el-tab-pane>
            <el-tab-pane label="主食" name="staple"></el-tab-pane>
            <el-tab-pane label="热菜" name="hot"></el-tab-pane>
            <el-tab-pane label="凉菜" name="cold"></el-tab-pane>
            <el-tab-pane label="汤品" name="soup"></el-tab-pane>
            <el-tab-pane label="点心" name="snack"></el-tab-pane>
          </el-tabs>

          <!-- 菜品列表 -->
          <div class="food-list">
            <div
              class="food-item"
              v-for="item in filterFoodList"
              :key="item.id"
              @click="addToCart(item)"
            >
              <div class="food-img">
                <!-- <img :src="item.img" alt="item.name" /> -->
                 <img src="@/assets/beadhouse/zhushi.png" alt />
              </div>
              <div class="food-info">
                <div class="food-name">{{ item.name }}</div>
                <div class="food-desc">{{ item.desc }}</div>
                <div class="food-price">¥{{ item.price.toFixed(2) }}</div>
                <el-button size="mini" type="primary" icon="el-icon-plus" style="width: 120px;">
                  加入购物车
                </el-button>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <!-- 底部提交按钮区 -->
    <div class="submit-section">
      <el-button
        type="danger"
        icon="el-icon-delete"
        @click="clearCart"
        :disabled="cartList.length === 0"
      >
        清空购物车
      </el-button>
      <div class="submit-right">
        <span class="submit-total">总计：¥{{ totalAmount.toFixed(2) }}</span>
        <el-button
          type="primary"
          icon="el-icon-check"
          @click="submitOrder"
          :disabled="!currentElderly || cartList.length === 0"
        >
          提交订单
        </el-button>
      </div>
    </div>

    <!-- 历史订单弹窗 -->
    <el-dialog
      title="长者历史订单"
      :visible.sync="showOrderList"
      width="80%"
      :close-on-click-modal="false"
    >
      <el-table :data="orderList" border stripe style="width: 100%">
        <el-table-column prop="orderNo" label="订单编号" width="180"></el-table-column>
        <el-table-column prop="elderlyName" label="长者姓名" width="120"></el-table-column>
        <el-table-column prop="orderTime" label="下单时间" width="180"></el-table-column>
        <el-table-column prop="totalAmount" label="订单金额" width="120">
          <template slot-scope="scope">¥{{ scope.row.totalAmount.toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="status" label="订单状态" width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'warning' : scope.row.status === 2 ? 'success' : 'danger'">
              {{ scope.row.status === 1 ? '待就餐' : scope.row.status === 2 ? '已就餐' : '已取消' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="diningType" label="就餐类型" width="120">
          <template slot-scope="scope">
            {{ scope.row.diningType === 1 ? '堂食' : '送餐上门' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="viewOrderDetail(scope.row)">
              查看详情
            </el-button>
            <el-button
              size="mini"
              type="danger"
              @click="cancelOrder(scope.row)"
              v-if="scope.row.status === 1"
            >
              取消订单
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 订单详情弹窗 -->
    <el-dialog
      title="订单详情"
      :visible.sync="showOrderDetail"
      width="60%"
      :close-on-click-modal="false"
    >
      <div v-if="currentOrder">
        <el-descriptions :column="2" border style="margin-bottom: 15px">
          <el-descriptions-item label="订单编号" :span="2">{{ currentOrder.orderNo }}</el-descriptions-item>
          <el-descriptions-item label="长者姓名">{{ currentOrder.elderlyName }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ currentOrder.elderlyPhone }}</el-descriptions-item>
          <el-descriptions-item label="下单时间">{{ currentOrder.orderTime }}</el-descriptions-item>
          <el-descriptions-item label="订单状态">
            <el-tag :type="currentOrder.status === 1 ? 'warning' : currentOrder.status === 2 ? 'success' : 'danger'">
              {{ currentOrder.status === 1 ? '待就餐' : currentOrder.status === 2 ? '已就餐' : '已取消' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="就餐类型">{{ currentOrder.diningType === 1 ? '堂食' : '送餐上门' }}</el-descriptions-item>
          <el-descriptions-item label="送餐地址" :span="2" v-if="currentOrder.diningType === 2">
            {{ currentOrder.address }}
          </el-descriptions-item>
        </el-descriptions>

        <el-table :data="currentOrder.foodItems" border style="width: 100%">
          <el-table-column prop="name" label="菜品名称"></el-table-column>
          <el-table-column prop="price" label="单价">
            <template slot-scope="scope">¥{{ scope.row.price.toFixed(2) }}</template>
          </el-table-column>
          <el-table-column prop="quantity" label="数量"></el-table-column>
          <el-table-column prop="subtotal" label="小计">
            <template slot-scope="scope">¥{{ scope.row.subtotal.toFixed(2) }}</template>
          </el-table-column>
        </el-table>

        <div style="text-align: right; margin-top: 10px; font-size: 16px">
          订单总计：¥{{ currentOrder.totalAmount.toFixed(2) }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "MealOrderManagement",
  data() {
    return {
      // 固定老人数据
      elderlyList: [
        {
          id: 1,
          name: "张小康",
          age: 78,
          phone: "13800138000",
          community: "幸福社区",
          diningType: 1, // 1-堂食 2-送餐上门
          address: "",
          remark: "低盐低脂"
        },
        {
          id: 2,
          name: "李光",
          age: 82,
          phone: "13900139000",
          community: "阳光社区",
          diningType: 2,
          address: "阳光小区3栋2单元501室",
          remark: "糖尿病餐，无糖"
        },
        {
          id: 3,
          name: "王乐乐",
          age: 75,
          phone: "13700137000",
          community: "康乐社区",
          diningType: 2,
          address: "康乐路88号康乐小区10栋1单元102",
          remark: "咀嚼困难，需软烂"
        },
        {
          id: 4,
          name: "赵祥",
          age: 80,
          phone: "13600136000",
          community: "祥和社区",
          diningType: 1,
          address: "",
          remark: "无特殊要求"
        }
      ],
      // 固定菜品数据
      foodList: [
        {
          id: 1,
          name: "白米饭",
          desc: "软糯白米饭",
          price: 2.0,
          type: "staple", // staple-主食 hot-热菜 cold-凉菜 soup-汤品 snack-点心
          img: "https://img1.baidu.com/it/u=3808069427,2869560663&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500"
        },
        {
          id: 2,
          name: "小米粥",
          desc: "养胃小米粥",
          price: 3.0,
          type: "staple",
          img: "https://img2.baidu.com/it/u=2052173620,3894307772&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=800"
        },
        {
          id: 3,
          name: "清蒸鱼",
          desc: "低盐清蒸鲈鱼",
          price: 28.0,
          type: "hot",
          img: "https://img0.baidu.com/it/u=1568652619,2055000775&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=1067"
        },
        {
          id: 4,
          name: "清炒时蔬",
          desc: "清炒西兰花",
          price: 12.0,
          type: "hot",
          img: "https://img2.baidu.com/it/u=3729179009,1737003379&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=1000"
        },
        {
          id: 5,
          name: "凉拌黄瓜",
          desc: "少油凉拌黄瓜",
          price: 8.0,
          type: "cold",
          img: "https://img1.baidu.com/it/u=2181572309,3075637131&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=750"
        },
        {
          id: 6,
          name: "番茄蛋汤",
          desc: "清淡番茄蛋汤",
          price: 10.0,
          type: "soup",
          img: "https://img2.baidu.com/it/u=1596362129,1759057234&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=1067"
        },
        {
          id: 7,
          name: "南瓜饼",
          desc: "无糖南瓜饼",
          price: 15.0,
          type: "snack",
          img: "https://img0.baidu.com/it/u=1527826607,2760071813&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=882"
        },
        {
          id: 8,
          name: "蒸蛋羹",
          desc: "嫩滑蒸蛋羹",
          price: 10.0,
          type: "hot",
          img: "https://img2.baidu.com/it/u=1231033603,3752162209&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=1067"
        }
      ],
      // 固定历史订单数据
      orderList: [
        {
          orderNo: "ORDER20250501001",
          elderlyId: 1,
          elderlyName: "张三",
          elderlyPhone: "13800138000",
          orderTime: "2025-05-01 10:20:30",
          totalAmount: 42.0,
          status: 2, // 1-待就餐 2-已就餐 3-已取消
          diningType: 1,
          address: "",
          foodItems: [
            { name: "白米饭", price: 2.0, quantity: 1, subtotal: 2.0 },
            { name: "清蒸鱼", price: 28.0, quantity: 1, subtotal: 28.0 },
            { name: "番茄蛋汤", price: 10.0, quantity: 1, subtotal: 10.0 },
            { name: "凉拌黄瓜", price: 8.0, quantity: 0.5, subtotal: 4.0 }
          ]
        },
        {
          orderNo: "ORDER20250501002",
          elderlyId: 2,
          elderlyName: "李四",
          elderlyPhone: "13900139000",
          orderTime: "2025-05-01 11:15:20",
          totalAmount: 30.0,
          status: 1,
          diningType: 2,
          address: "阳光小区3栋2单元501室",
          foodItems: [
            { name: "小米粥", price: 3.0, quantity: 1, subtotal: 3.0 },
            { name: "蒸蛋羹", price: 10.0, quantity: 1, subtotal: 10.0 },
            { name: "南瓜饼", price: 15.0, quantity: 1, subtotal: 15.0 },
            { name: "清炒时蔬", price: 12.0, quantity: 0.1667, subtotal: 2.0 }
          ]
        },
        {
          orderNo: "ORDER20250430001",
          elderlyId: 3,
          elderlyName: "王五",
          elderlyPhone: "13700137000",
          orderTime: "2025-04-30 09:30:15",
          totalAmount: 23.0,
          status: 3,
          diningType: 2,
          address: "康乐路88号康乐小区10栋1单元102",
          foodItems: [
            { name: "白米饭", price: 2.0, quantity: 1, subtotal: 2.0 },
            { name: "清炒时蔬", price: 12.0, quantity: 1, subtotal: 12.0 },
            { name: "番茄蛋汤", price: 10.0, quantity: 0.9, subtotal: 9.0 }
          ]
        }
      ],

      // 页面交互数据
      selectedElderlyId: "", // 选中的老人ID
      currentElderly: null, // 当前选中的老人信息
      foodSearch: "", // 菜品搜索关键词
      activeFoodType: "all", // 选中的菜品分类
      cartList: [], // 购物车列表
      showOrderList: false, // 是否显示历史订单弹窗
      showOrderDetail: false, // 是否显示订单详情弹窗
      currentOrder: null // 当前查看的订单详情
    };
  },
  computed: {
    // 过滤后的菜品列表
    filterFoodList() {
      let list = this.foodList;
      // 分类过滤
      if (this.activeFoodType !== "all") {
        list = list.filter(item => item.type === this.activeFoodType);
      }
      // 关键词过滤
      if (this.foodSearch) {
        list = list.filter(item => item.name.includes(this.foodSearch));
      }
      return list;
    },
    // 购物车总金额
    totalAmount() {
      return this.cartList.reduce((total, item) => {
        return total + item.price * item.quantity;
      }, 0);
    }
  },
  methods: {
    // 获取选中老人的信息
    getElderlyInfo() {
      this.currentElderly = this.elderlyList.find(item => item.id === this.selectedElderlyId) || null;
    },
    // 加入购物车
    addToCart(food) {
      if (!this.currentElderly) {
        this.$message.warning("请先选择就餐长者！");
        return;
      }
      // 检查是否已在购物车
      const index = this.cartList.findIndex(item => item.id === food.id);
      if (index > -1) {
        this.cartList[index].quantity += 1;
      } else {
        this.cartList.push({
          id: food.id,
          name: food.name,
          price: food.price,
          quantity: 1
        });
      }
      this.$message.success(`${food.name} 已加入购物车`);
    },
    // 清空购物车
    clearCart() {
      this.$confirm("确定要清空购物车吗？", "提示", {
        type: "warning"
      }).then(() => {
        this.cartList = [];
        this.$message.success("购物车已清空");
      });
    },
    // 提交订单
    submitOrder() {
      // 生成订单编号
      const orderNo = `ORDER${new Date().getTime()}`;
      // 构造订单数据
      const newOrder = {
        orderNo,
        elderlyId: this.currentElderly.id,
        elderlyName: this.currentElderly.name,
        elderlyPhone: this.currentElderly.phone,
        orderTime: new Date().toLocaleString(),
        totalAmount: this.totalAmount,
        status: 1,
        diningType: this.currentElderly.diningType,
        address: this.currentElderly.address,
        foodItems: this.cartList.map(item => ({
          name: item.name,
          price: item.price,
          quantity: item.quantity,
          subtotal: item.price * item.quantity
        }))
      };
      // 添加到订单列表
      this.orderList.unshift(newOrder);
      // 清空购物车
      this.cartList = [];
      this.$message.success(`订单提交成功！订单编号：${orderNo}`);
    },
    // 查看订单详情
    viewOrderDetail(order) {
      this.currentOrder = order;
      this.showOrderDetail = true;
    },
    // 取消订单
    cancelOrder(order) {
      this.$confirm(`确定要取消订单【${order.orderNo}】吗？`, "提示", {
        type: "danger"
      }).then(() => {
        const index = this.orderList.findIndex(item => item.orderNo === order.orderNo);
        if (index > -1) {
          this.orderList[index].status = 3;
          this.$message.success("订单已取消");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.meal-order-container {
  padding: 20px;
  background-color: #f5f7fa;
  height: calc(100vh - 120px);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  h2 {
    margin: 0;
    color: #1f2d3d;
  }
}

.order-main {
  display: flex;
  gap: 20px;
  height: calc(100vh - 260px);
}

// 左侧老人区域
.elderly-section {
  width: 350px;
  flex-shrink: 0;
  .elderly-card {
    height: 100%;
    .card-header {
      font-size: 16px;
      font-weight: 600;
    }
    .elderly-info {
      margin-top: 15px;
    }
    .selected-foods {
      margin-top: 20px;
      .cart-header {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 10px;
        padding-bottom: 5px;
        border-bottom: 1px solid #e4e7ed;
      }
      .cart-item {
        display: flex;
        justify-content: space-between;
        padding: 5px 0;
        border-bottom: 1px dashed #e4e7ed;
        .price {
          color: #f56c6c;
        }
      }
      .cart-total {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        font-weight: 600;
        .total-price {
          color: #f56c6c;
        }
      }
    }
  }
}

// 右侧菜品区域
.food-section {
  flex: 1;
  .food-card {
    height: 100%;
    overflow: auto;
    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      font-weight: 600;
    }
    .food-list {
      display: inline-flex;
      flex-wrap: wrap;
      gap: 20px;
      padding: 0;
      .food-item {
        width: 230px;
        display: flex;
        gap: 10px;
        padding: 10px;
        border: 1px solid #e4e7ed;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s;
        &:hover {
          border-color: #409eff;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }
        .food-img {
          width: 80px;
          height: 80px;
          flex-shrink: 0;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
          }
        }
        .food-info {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .food-name {
            font-size: 15px;
            font-weight: 600;
            color: #1f2d3d;
          }
          .food-desc {
            font-size: 12px;
            color: #909399;
            margin: 5px 0;
          }
          .food-price {
            font-size: 14px;
            color: #f56c6c;
            font-weight: 600;
          }
        }
      }
    }
  }
}

// 底部提交区域
.submit-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: #fff;
  border-radius: 8px;
  margin-top: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  .submit-right {
    display: flex;
    align-items: center;
    gap: 15px;
    .submit-total {
      font-size: 18px;
      font-weight: 600;
      color: #f56c6c;
    }
  }
}

// 滚动条样式
::v-deep .el-card__body {
  overflow: auto;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background-color: #ccc;
  }
}
</style>